import { isCheckinStage } from '../workflow/stagesControl'
import { ON_CHECKIN_STAGE } from '../status/statusControl'

export function checkinStatus(stage) {
  return {
    match: isCheckinStage(stage),
    status: ON_CHECKIN_STAGE
  }
}
